import { FunctionComponent } from "react";

import {
  FontSizes,
  FontWeights,
  Stack,
  Text,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize
} from "@bps/fluent-ui";

export const SMS_CHARACTER_LIMIT = 160;

interface SmsCharacterCountProps {
  count: number;
}

export const SmsCharacterCount: FunctionComponent<SmsCharacterCountProps> = ({
  count
}) => {
  const isOverLimit = count > SMS_CHARACTER_LIMIT;

  return (
    <Stack
      horizontal
      horizontalAlign="end"
      verticalAlign="center"
      tokens={{ childrenGap: 8 }}
    >
      {isOverLimit && (
        <TextBadge
          badgeSize={TextBadgeSize.small}
          badgeColor={TextBadgeColor.yellow}
          hasBorder={false}
        >
          Multiple SMS
        </TextBadge>
      )}
      <Text
        styles={{
          root: {
            fontSize: FontSizes.small,
            fontWeight: isOverLimit ? FontWeights.semibold : FontWeights.regular
          }
        }}
      >
        {count}/{SMS_CHARACTER_LIMIT}
      </Text>
    </Stack>
  );
};
